<div *ngIf="visible" class="banner relative">
  <!-- <h1
    class="absolute text-white"
    style="top: 50%; left: 50%; transform: translate(-50%, -100%); font-size: clamp(1rem, 10vw, 4rem)"
  >
    Flyers
  </h1> -->
  <img
    [src]="content"
    alt="Banner Image"
    alt=""
    class="w-full"
    style="min-height: 300px; height: auto; object-fit: cover" />
</div>
